import { Component, Input } from '@angular/core';
import { Summary } from '@app/core/models/summary.model';
import { TOOLTIP_CONTENT, TOOLTIP_DELAY } from '@app/presentation/mo-layout/tooltip.constant';
import { ETOOLTIP_POSITION } from '@app/core/enums/tooltip.enum';

@Component({
  selector: 'layout-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent {
  @Input() title!: string;
  @Input() summary: Summary;

  public ETOOLTIP_POSITION = ETOOLTIP_POSITION;
  public TOOLTIP_CONTENT = TOOLTIP_CONTENT;
  public TOOLTIP_DELAY = TOOLTIP_DELAY;
}
